import 'core-js/features/string/trim-start';
import merge from "lodash/merge";

const getExpires = string => {
  if (string.toLowerCase() === "session") return '';
  let id = string.slice(-1);
  let value = parseInt(string.slice(0, -1));
  let date = new Date();
  let factor = 1;
  switch (id) {
    case "s":
      factor = factor * 1000;
      break;
    case "m":
      factor = factor * 60 * 1000;
      break;
    case "h":
      factor = factor * 60 * 60 * 1000;
      break;
    case "d":
      factor = factor * 24 * 60 * 60 * 1000;
      break;
    default: return;
  }
  date.setTime(date.getTime() + value * factor);
  return `expires=${date.toUTCString()};`;
};

export default class Cookies {
  static set(config) {
    let defaults = {
      name: "",
      value: "",
      path: "/",
      expires: "365d",
      domain: "",
      secure: true,
      sameSite: "Lax"
    };
    let settings = merge(defaults, config);
    document.cookie = `${settings.name}=${settings.value};${getExpires(settings.expires)}${Boolean(settings.domain) ? "domain=" + settings.domain + ";" : ""}path=${settings.path};${Boolean(settings.secure) ? "Secure;" : ""}${Boolean(settings.sameSite) ? "SameSite=" + settings.sameSite : ""}`;
  }
  static get(cookiename) {
    let name = cookiename + '=';
    let filtered = decodeURIComponent(document.cookie).split(";").filter(cookie => cookie.trimStart().indexOf(name) === 0);
    // return Boolean(filtered.length) ? filtered[0].split('=')[1] : "";
    return Boolean(filtered.length) ? filtered[0].replace(name, '') : "";
  }
  static delete(config) {
    let defaults = {
      name: "",
      path: "/",
      domain: "",
      secure: true,
      sameSite: "Lax"
    };
    let settings = merge(defaults, config);
    if (!Boolean(this.get(settings.name))) return;
    document.cookie = `${settings.name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;${Boolean(settings.domain) ? "domain=" + settings.domain + ";" : ""}path=${settings.path};${Boolean(settings.secure) ? "Secure;" : ""}${Boolean(settings.sameSite) ? "SameSite=" + settings.sameSite : ""}`;
  }
}
